import { FC, useState } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { SupportFormCard } from "./SupportFormCard/SupportFormCard";

import { useTranslate } from "@/common/hooks/useTranslate";
import { OrganizationPageOutput } from "@/common/types/trpc";
import { FormButton } from "@/forms-design-system/FormButton";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { ChevronDown } from "@/icons/outlined";

const SUPPORT_FORMS_STEP = 6;

interface OrganizationPageSupportProps {
  supportForms: OrganizationPageOutput["supportForms"];
}

export const OrganizationPageSupport: FC<OrganizationPageSupportProps> = ({ supportForms }) => {
  const { t } = useTranslate();
  const [visibleCount, setVisibleCount] = useState(SUPPORT_FORMS_STEP);
  const hasSingleForm = supportForms.length === 1;

  return (
    <Stack alignItems={{ sm: "center" }} gap={{ xs: 2, sm: 3 }} data-test="org-page-support-forms">
      <FormTypography variant="h6" vibe="brand" sx={{ textTransform: "uppercase" }}>
        {t("organization", "otherCampaigns")}
      </FormTypography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: hasSingleForm ? "1fr" : "repeat(2, minmax(0, 1fr))" },
          gap: 2,
          width: "100%",
        }}
      >
        {supportForms.slice(0, visibleCount).map((form) => (
          <SupportFormCard key={form.id} form={form} />
        ))}
      </Box>

      {supportForms.length > visibleCount ? (
        <Stack direction="row" justifyContent="center" sx={{ width: "100%", marginTop: { xs: 3, sm: 2 } }}>
          <FormButton
            variant="outline"
            size="medium"
            onClick={() => setVisibleCount((count) => count + SUPPORT_FORMS_STEP)}
            endIcon={<ChevronDown />}
            data-test="org-page-support-forms-see-more"
          >
            {t("common", "seeMore")}
          </FormButton>
        </Stack>
      ) : null}
    </Stack>
  );
};
